/**
 * 券墙组件常量
 */

import { getCouponWall, getCouponWallForWaimai, receiveCoupon, receiveCouponForWaimai } from "@/api/coupon";
import { CouponWallScene, PreviewStatus } from "@/types/coupon-wall";

// 券墙场景
export const COUPON_ACTIVITY_SCENE = 1;

// 预发券接口映射
export const GET_COUPON_WALL_API_MAP = {
  [CouponWallScene.FX_CENTER]: getCouponWall,
  [CouponWallScene.WAIMAI]: getCouponWallForWaimai,
}

// 领券接口映射
export const RECEIVE_COUPON_API_MAP = {
  [CouponWallScene.FX_CENTER]: receiveCoupon,
  [CouponWallScene.WAIMAI]: receiveCouponForWaimai,
}


/**
 * 不同场景对应的韦恩供给召回判定接口入参 src
 */
export const COUPON_WALL_CHECK_WAYNE_SRC_MAP = {
  [CouponWallScene.FX_CENTER]: 'wm_fenxiao_center_page',
  [CouponWallScene.WAIMAI]: 'wm_merchant_commission_venue',
}


// 发券渠道
export const COUPON_CHANNEL_MAP = {
  [CouponWallScene.FX_CENTER]: 3,
  [CouponWallScene.WAIMAI]: null, // 接口不使用 couponChannel，但是埋点上报需要
}

export const LX_COUPON_CHANNEL_MAP = {
  [CouponWallScene.FX_CENTER]: 3,
  [CouponWallScene.WAIMAI]: 7,
}

// 红包墙埋点参数值：券墙状态枚举
export enum CouponWallStatus {
  NOT_RECEIVED = 0, // 未领取
  RECEIVED = 1, // 已领取
  ERROR = 2, // 预发券错误
  NOT_LOGIN = 3, // 未登录
}

// 领券方式枚举
export enum ReceiveCouponButtonStyle {
  AUTO = 0, // 自动
  MANUAL = 1, // 手动
}

// 点击券去使用按钮跳转类型
export enum CouponUseButtonJumpPageType {
  SUPPLY_AREA = 1, // 供给区域
  OTHER = 2, // 其他
}


// 预发券状态
export enum PreSendStatus {
  PENDING = 'pending',    // 等待预发券
  SUCCESS = 'success',    // 预发券成功（可用）
  FAIL = 'fail',          // 预发券失败
}

// 领券状态
export enum ReceiveStatus {
  IDLE = 'idle',          // 未开始
  RECEIVING = 'receiving', // 领券中
  SUCCESS = 'success',    // 领券成功
  FAIL = 'fail',          // 领券失败
}

export enum CouponWallRenderStatus {
  // 加载状态
  LOADING = 'loading', // 预发券未返回，未命中实验展示骨架屏
  LOADING_PREVIEW = 'loadingPreview', // 预发券未返回，命中实验展示静态图（可点击领券）
  // 未登录
  NOT_LOGIN = 'notLogin',
  // 错误兜底态
  ERROR = 'error',
  // 预发券成功，等待用户操作
  HAS_UNRECEIVED_COUPON = 'hasUnreceivedCoupon', // 预发券成功，存在待领取的券，展示真实券墙
  // 领券中
  RECEIVING_PREVIEW = 'receivingPreview', // 领券中，触发领券时预发券未返回（命中实验，展示静态图）
  RECEIVING = 'receiving', // 领券中，预发券已返回（展示真实预发券墙）
  // 领券成功 ｜ 预发券成功，不存在待领取的券
  RECEIVED = 'received', // 领券成功，展示真实券墙
}

export const PreviewStatusMap: Record<
  CouponWallRenderStatus.LOADING_PREVIEW | CouponWallRenderStatus.RECEIVING_PREVIEW | CouponWallRenderStatus.NOT_LOGIN, 
  PreviewStatus
> = {
  [CouponWallRenderStatus.LOADING_PREVIEW]: PreviewStatus.LOADING,
  [CouponWallRenderStatus.RECEIVING_PREVIEW]: PreviewStatus.RECEIVING,
  [CouponWallRenderStatus.NOT_LOGIN]: PreviewStatus.NOT_LOGIN,
}

// 埋点上报红包墙曝光状态
export enum ExposureStateEnum {
  PREVIEW = 0, // 静态图
  PRE_SEND = 1, // 真实的预发券
}
